import React, { useState, useEffect } from 'react'

import { Fab, Grid } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import axios from 'axios'
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom'

import BackDrop from 'components/BackDrop'
import { WhatsappIcon } from 'components/icons/personalizedIcons'
import PrivateRoute from 'components/PrivateRoute'
import {
  DEFAULT_IP,
  FEATURE_FLAG_UNDER_CONSTRUCTION,
  FEATURE_FLAG_HUBSPOT_TICKET,
  FEATURE_FLAG_WHATSAPP_CONTACT,
} from 'constants/appConstants'
import { routeBase } from 'constants/environments.constants'
import { NAME_CONFIGURATION_RETURN } from 'constants/timeModal'
import { FEATURES_FLAGS, GET_ALL_SETTINGS_GROUPS, GET_SETTINGS_GROUPS_BY_ID } from 'constants/urls'
import { AuthContextProvider } from 'contextApi/AuthContext'
import ItinerariesContextProvider from 'contextApi/ItineraryContext'
import { ProductProvider } from 'contextApi/ProductContext'
import AdminLayout from 'layouts/Admin'
import getClientIp from 'services/utilityServices'
import { encryptAES256CBC, decryptAES256CBC } from 'utils/encryptData'
import AuthorizationShopify from 'views/AuthorizationShopify/AuthorizationShopify'
import CreateBonus from 'views/Bonus/CreateBonus'
import ThanksBonus from 'views/Bonus/ThanksBonus'
import ConfirmUser from 'views/ConfirmUser'
import CouponActivation from 'views/Coupons/CouponActivation'
import InConstruction from 'views/InConstruction'
import LoginPage from 'views/Login'
import RecoveredPassword from 'views/RecoveredPassword'
import RefreshTemplate from 'views/RefreshTemplate'
import Shopify from 'views/Shopify'
import DetailSellerStore from 'views/StoreDetail/DetailSellerStore'
import ThanksRegister from 'views/StoreDetail/ThanksRegister'
import RegisterStore from 'views/StoreRegister/RegisterStore'

const useStyles = makeStyles((theme) => ({
  marginFloat: {
    zIndex: 9999,
    background: '#4dc247',
    backgroundColor: '#4dc247',
    fill: 'white',
    position: 'fixed',
    bottom: '50px',
    right: '16px',
    width: '40px',
    height: '40px',
    boxShadow: '-4px 4px 0px rgba(0, 0, 0, 0.1)',
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
}))

const App = () => {
  const NC_WEB_COMPONENT = routeBase[process.env.REACT_APP_ENVIRONMENT].NOTIFICATION_CONFIGURATOR
  const classes = useStyles()
  const [url, setUrl] = useState('https://wa.link/udel3x')
  const [hubspotTicketUrl, setHubspotTicketUrl] = useState('')
  const [clientIp, setClientIp] = useState(DEFAULT_IP)
  const [curtains, setCurtains] = useState(false)
  const getfeatureFlag = async (ip) => {
    await axios
      .get(`${FEATURES_FLAGS}`, {
        headers: {
          'X-Client-Token': encryptAES256CBC(ip),
        },
      })
      .then((response) => {
        const dataFilter = response.data.find(
          (data) => data.name === FEATURE_FLAG_UNDER_CONSTRUCTION
        )
        setCurtains(dataFilter?.value === 'true')
        const hubspotTicket = response.data.find(
          (data) => data.name === FEATURE_FLAG_HUBSPOT_TICKET
        )
        if (hubspotTicket) {
          setHubspotTicketUrl(hubspotTicket.value)
        }
        const whatsappContact = response.data.find(
          (data) => data.name === FEATURE_FLAG_WHATSAPP_CONTACT
        )
        if (whatsappContact?.value) {
          setUrl(whatsappContact.value)
        }
      })
      .catch(() => {
        setCurtains(false)
      })
  }
  const getSettingsGroupsById = async (id, ip) => {
    await axios
      .get(`${GET_SETTINGS_GROUPS_BY_ID}/${id}`, {
        headers: {
          'X-Client-Token': encryptAES256CBC(ip),
        },
      })
      .then((response) => {
        const settingModal = response.data.find(
          (setting) => setting.settingGroupId.toString() === id.toString()
        )
        if (settingModal) localStorage.setItem('timeModal', settingModal.value)
      })
      .catch(() => {
        setCurtains(false)
      })
  }
  const getAllSettingsGroups = async (ip) => {
    await axios
      .get(`${GET_ALL_SETTINGS_GROUPS}`, {
        headers: {
          'X-Client-Token': encryptAES256CBC(ip),
        },
      })
      .then((response) => {
        const configuration = response.data.find((item) => item.name === NAME_CONFIGURATION_RETURN)
        if (configuration) {
          getSettingsGroupsById(configuration.id, ip)
        }
      })
      .catch(() => {
        setCurtains(false)
      })
  }
  const getProductClientIp = async () => {
    if (clientIp !== DEFAULT_IP) return clientIp
    const sessionClientIp = sessionStorage.getItem('clientIp')
    if (sessionClientIp) {
      const decryptedClientIp = decryptAES256CBC(sessionClientIp)
      setClientIp(decryptedClientIp)
      return decryptedClientIp
    }
    try {
      const response = await getClientIp()
      sessionStorage.setItem('clientIp', encryptAES256CBC(response))
      setClientIp(response)
      return response
    } catch (error) {
      setClientIp(DEFAULT_IP)
      return DEFAULT_IP
    }
  }
  useEffect(() => {
    getProductClientIp().then((ip) => {
      getfeatureFlag(ip)
      getAllSettingsGroups(ip)
    })
    const script = document.createElement('script')
    script.src = `${NC_WEB_COMPONENT}`
    document.head.appendChild(script)
  }, [window.location])
  if (clientIp === DEFAULT_IP) {
    return <BackDrop open />
  }
  return (
    <>
      {!curtains ? (
        <>
          <Grid item xs={1}>
            <a href={url} target="_blank" rel="noreferrer">
              <Fab
                size="medium"
                color="inherit"
                aria-label="add"
                component="div"
                className={classes.marginFloat}
              >
                <WhatsappIcon />
              </Fab>
            </a>
          </Grid>
          <Router>
            <AuthContextProvider clientIpAddress={clientIp} hubspotTicketUrl={hubspotTicketUrl}>
              <ProductProvider>
                <ItinerariesContextProvider>
                  <Switch>
                    <PrivateRoute path="/admin" component={AdminLayout} />
                    <Route path="/" exact component={LoginPage} />
                    <Route path="/login" component={LoginPage} />
                    <Route
                      path="/Account/resetpassword/:userEmail/:code"
                      component={RecoveredPassword}
                    />
                    <Route path="/Account/Confirm/:userEmail/:code" component={ConfirmUser} />
                    <Route path="/register/Detail/:email" component={DetailSellerStore} />
                    <Route path="/register/thanks" component={ThanksRegister} />
                    <Route path="/bonos/thanks" component={ThanksBonus} />
                    <Route path="/bonos/:nit" component={CreateBonus} />
                    <Route path="/shopify-authorization" component={AuthorizationShopify} />
                    <Route path="/shopify" component={Shopify} />
                    <Route path="/registerStore" component={RegisterStore} />
                    <Route path="/coupon-activation" component={CouponActivation} />
                    <Route path="/refresh-template" component={RefreshTemplate} />
                    <Redirect from="/" to="/admin/orders" />
                  </Switch>
                </ItinerariesContextProvider>
              </ProductProvider>
            </AuthContextProvider>
          </Router>
        </>
      ) : (
        <InConstruction />
      )}
    </>
  )
}

export default App
